module.exports = __webpack_public_path__ + "static/media/tickets.d1704c52.svg";